var map = {
	"./art.png": "1f57",
	"./computing.png": "d921",
	"./design-tech.png": "3c2a",
	"./drama.png": "1894",
	"./english.png": "20ff",
	"./geography.png": "d46f",
	"./history.png": "1e7e",
	"./languages.png": "d916",
	"./maths.png": "581e",
	"./mfl.png": "fbbd",
	"./music.png": "e184",
	"./pe.png": "d2aa",
	"./phse.png": "0650",
	"./re.png": "bcad",
	"./science.png": "349f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b878";